<template>
	<div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true"  :model="formdata" class="form-inline">
					<el-form-item label="微信昵称">
						<el-input v-model="formdata.nickname" placeholder="请输入微信昵称" class="w200 mr10" size="small"></el-input>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="timeData"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="title" label="商家活动">
					<div slot-scope="scope" >
						<span :title="scope.row.title ">{{scope.row.title | ellipsis}}</span>
					</div>
				</el-table-column >
				<!-- <el-table-column prop="nickname" label="微信昵称"></el-table-column> -->
				<el-table-column label="微信" align="center">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
						<p>{{scope.row.nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="ip" label="购买地址"></el-table-column>
				<el-table-column prop="create_time" label="分享时间">
					<div slot-scope="scope" >
						<span>{{scope.row.create_time.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.create_time.split(" ")[1]}}</span>
					</div>
				</el-table-column>
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					:page-size="page.page_size"
					:current-page="page.current_page"
					layout="total, prev, pager, next"
					:total="page.total_rows"
					@current-change="pageIndexChange"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import api from "@/api.js";
	import { pagination1 } from "@/util/util.js";
	export default {
		name: 'sharelogin',
		filters: {//限制文本显示字数,超出部分用...代替
			ellipsis (value) {
				if (!value) return ''
				if (value.length > 10) {
					return value.slice(0,10) + '...'
				}
				return value
			}
		},
		data() {
		  return {
		    formdata: {
		      page: 1, // 	整型 	必填 	- 	- 	页码
		      nickname: '', // 	整型 	必填 	- 	- 	员工名称搜索
		      start_time: '',
					end_time: '',
					activity_id: '',
					status: 1
		    },
		    tabIndex: 0,
		    timeData: [],
		    tableData: [],
				page: {
					current_page: pagination1.current_page,
					page_size: pagination1.page_size,
					total_rows: pagination1.total_rows
				},
		    pickerOptions1: {
		      disabledDate(time) {
		        return time.getTime() > Date.now(); // - 8.64e7 减去就是不包含今天的
		      }
		    }
		  };
		},
		created() {
			this.formdata.activity_id = this.$route.query.id || "";
		  this.init();
		},
		methods: {
		  //初始化请求
		  init() {
		    this.querycustom();
		  },
		  // 查询
		  querycustom() {
		    if (this.timeData && this.timeData.length > 0) {
		      this.formdata.start_time = this.timeData[0]
		      this.formdata.end_time = this.timeData[1]
		    } else {
		      this.formdata.start_time = ""
		      this.formdata.end_time = ""
		    }
		    this.axios
					.post(api.getInvitationLog, this.formdata)
					.then(response => {
						if (response.data.code == 0) {
							this.tableData = response.data.result;
							this.page = response.data.page;
						} 
					})
					.catch(response => {
					});
		  },
		  searchcustomer() {
		    this.formdata.page = 1
		    this.querycustom()
		  },
		  pageIndexChange(pageindex) {
		    this.formdata.page = pageindex;
		    this.querycustom();
		  }
		}
	}
</script>

<style scoped>
.condition .el-form-item{margin-bottom: 10px;}
</style>